import { render } from "./HospitalDetails.vue?vue&type=template&id=66719112"
import script from "./HospitalDetails.vue?vue&type=script&lang=js"
export * from "./HospitalDetails.vue?vue&type=script&lang=js"

import "./HospitalDetails.vue?vue&type=style&index=0&id=66719112&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/HospitalDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66719112"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66719112', __exports__)) {
    console.log('reload')
    api.reload('66719112', __exports__)
  }
  
  module.hot.accept("./HospitalDetails.vue?vue&type=template&id=66719112", () => {
    console.log('re-render')
    api.rerender('66719112', render)
  })

}


export default __exports__